import { createFileRoute } from '@tanstack/react-router'
import { SupplierReturnPrintPage } from '../../../../features/purchasing/return-print-page'
import { printSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/supplier-returns/$returnId/print')({
  staticData: { crumb: 'supplierReturnPrint' },
  validateSearch: printSearchSchema,
  component: SupplierReturnPrintPage,
})
